/**
 * Created by andrey on 25.02.2026
 */

class BucketsTransportData {
    constructor(buckets = 32) {
        this.buckets = buckets;
        this.data = {};
    }

    getBucketKey(index) {
        return `syncbucket_${index}`;
    }

    getBucketIndex(key) {
        return (connector.utils.hashCode(key) % this.buckets + this.buckets) % this.buckets;
    }

    addData(data) {
        const dirty = {};

        for (const key in data) {
            const bucketKey = this.getBucketKey(this.getBucketIndex(key));
            if (!this.data[bucketKey]) {
                this.data[bucketKey] = {};
            }

            if (data[key] === "") {
                delete this.data[bucketKey][key];
            } else {
                this.data[bucketKey][key] = data[key];
            }

            dirty[bucketKey] = this.data[bucketKey];
        }

        return dirty;
    }

    clearData() {
        const dirty = {};

        for (const bucketKey in this.data) {
            dirty[bucketKey] = this.data[bucketKey] = {};
        }

        return dirty;
    }

    getSessionBucketKey() {
        return this.getBucketKey(this.getBucketIndex("session"));
    }

    getAllBucketKeys() {
        return Array.from({ length: this.buckets }, (_, i) => this.getBucketKey(i));
    }

    parseResponse(data) {
        const result = {};

        for (const bucketKey in data) {
            if (!data[bucketKey] || typeof data[bucketKey] !== "object") {
                continue;
            }

            this.data[bucketKey] = data[bucketKey];
            Object.assign(result, data[bucketKey]);
        }

        return result;
    }

    setData(data) {
        this.data = data;
    }
}
